import DigitalMarketingServicePage from '../digital-marketing/DigitalMarketingServicePage';
import { getDigitalMarketingService } from '../digital-marketing/services';

const LocalSeo = () => {
  const service = getDigitalMarketingService('local-seo');
  if (!service) return null;
  return <DigitalMarketingServicePage service={service} />;
};

export default LocalSeo;
